import styled from 'styled-components';

const TextSeparator = styled.span`
  color: #8EA3B5;
  margin: 0 6px;
  font-size: 14px;
`;

export default TextSeparator;
